import { ErrorPage } from "../../../components/Error";

export default ErrorPage;
